import { render, staticRenderFns } from "./moreInfo.vue?vue&type=template&id=a06a4db4&scoped=true&"
import script from "./moreInfo.vue?vue&type=script&lang=js&"
export * from "./moreInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a06a4db4",
  null
  
)

export default component.exports